export function isResearchSession(conversationId) {
    return (conversationId === null || conversationId === void 0 ? void 0 : conversationId.startsWith('research-session-') // Old Format research-session-1
    )
        || (conversationId === null || conversationId === void 0 ? void 0 : conversationId.startsWith('rs-')) || false; // New Format rs-csa@amazon-17323234343
}
//# sourceMappingURL=IsResearchSession.js.map